export default __webpack_public_path__ + "static/media/icon-family.8bc23554.svg";